import { render } from "./applySealCheck.vue?vue&type=template&id=5922f9a1"
import script from "./applySealCheck.vue?vue&type=script&lang=js"
export * from "./applySealCheck.vue?vue&type=script&lang=js"

import "./applySealCheck.vue?vue&type=style&index=0&id=5922f9a1&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__